import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';

// Components
import GlobalSchema from '@/components/GlobalSchema';
import BackgroundAudio from '@/components/BackgroundAudio';

// Pages
import HomePage from '@/pages/HomePage';
import ServicePage from '@/pages/ServicePage';
import CoverageHub from '@/pages/CoverageHub';
import CityPage from '@/pages/CityPage';
import CityServicePage from '@/pages/CityServicePage';
import DistrictPage from '@/pages/DistrictPage';
import PlzPage from '@/pages/PlzPage';
import ContactPage from '@/pages/ContactPage';
import ImpressumPage from '@/pages/ImpressumPage';
import DatenschutzPage from '@/pages/DatenschutzPage';
import AgbPage from '@/pages/AgbPage';

function App() {
  return (
    <>
      <GlobalSchema />
      <BackgroundAudio />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/leistungen/:kategorie" element={<ServicePage />} />
          <Route path="/einsatzgebiete" element={<CoverageHub />} />
          <Route path="/einsatzgebiete/:citySlug" element={<CityPage />} />
          <Route path="/einsatzgebiete/:citySlug/:serviceSlug" element={<CityServicePage />} />
          <Route path="/einsatzgebiete/:citySlug/stadtteil/:districtSlug" element={<DistrictPage />} />
          <Route path="/plz/:plz" element={<PlzPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/agb" element={<AgbPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;